import React from "react";
import { NavLink } from "react-router-dom";

const isMenuStatusActive = (status) => Number(status) === 1;

// Helper to render directory sub-modules (agendas, speakers, other)
export function renderDirectorySubModule(menu, i) {
  if (!isMenuStatusActive(menu.status)) {
    return null;
  }

  return (
    <React.Fragment key={i}>
      {menu.alias === "agendas" && (
        <li>
          <NavLink
            isActive={(match, location) => location.pathname === `/event/module/documents/agendas/${menu.id}`}
            to={`/event/module/documents/agendas/${menu.id}`}
          >
            {menu.name}
          </NavLink>
        </li>
      )}
      {menu.alias === "speakers" && (
        <li>
          <NavLink
            isActive={(match, location) => location.pathname === `/event/module/documents/speakers/${menu.id}`}
            to={`/event/module/documents/speakers/${menu.id}`}
          >
            {menu.name}
          </NavLink>
        </li>
      )}
      {menu.alias === "other" && (
        <li>
          <NavLink
            isActive={(match, location) => location.pathname === `/event/module/documents/other/${menu.id}`}
            to={`/event/module/documents/other/${menu.id}`}
          >
            {menu.name}
          </NavLink>
        </li>
      )}
    </React.Fragment>
  );
}

// Helper to render a single module item. Pass in helpers: { isMenuItemAvailable, t, event, currentPath }
export function renderModuleItem(module, i, helpers = {}) {
  const { isMenuItemAvailable, event, currentPath } = helpers;

  if (!module || !isMenuStatusActive(module.status)) {
    return null;
  }

  return (
    <React.Fragment key={i}>
      {/* Information Pages First */}
      {module.alias === "information_pages" && isMenuItemAvailable("information_pages") && (
        <li>
          <NavLink to="/event/module/information-pages">
            <span>{module.value}</span>
          </NavLink>
        </li>
      )}
      {module.alias === "general_info" && isMenuItemAvailable("general-info") && (
        <li>
          <NavLink to="/event/module/general-information">
            <span>{module.value}</span>
          </NavLink>
        </li>
      )}
      {module.alias === "additional_info" && isMenuItemAvailable("additional-info") && (
        <li>
          <NavLink to="/event/module/additional-information">
            <span>{module.value}</span>
          </NavLink>
        </li>
      )}
      {module.alias === "infobooth" && isMenuItemAvailable("practical-info") && (
        <li>
          <NavLink to="/event/module/practical-information">
            <span>{module.value}</span>
          </NavLink>
        </li>
      )}
      {/* Other Modules */}
      {module.alias === "attendees" && isMenuItemAvailable("attendees") && (
        <li>
          <NavLink to="/event/module/attendees">
            <span className="active">{module.value}</span>
          </NavLink>
        </li>
      )}
      {module.alias === "agendas" && isMenuItemAvailable("agendas") && (
        <li>
          <NavLink to="/event/module/programs">
            <span>{module.value}</span>
          </NavLink>
        </li>
      )}
      {module.alias === "speakers" && isMenuItemAvailable("speakers") && (
        <li>
          <NavLink to="/event/module/speakers">
            <span>{module.value}</span>
          </NavLink>
        </li>
      )}
      {module.alias === "team" && isMenuItemAvailable("team") && (
        <li>
          <NavLink to="/event/module/teams">
            <span>{module.value}</span>
          </NavLink>
        </li>
      )}
      {module.alias === "news" && isMenuItemAvailable("news") && (
        <li>
          <NavLink to="/event/module/news">
            <span>{module.value}</span>
          </NavLink>
        </li>
      )}
      {module.alias === "subregistration" && (isMenuItemAvailable("subregistration") || isMenuItemAvailable("sub_registrations")) && (
        <li>
          <NavLink to="/event/module/sub-registration">
            <span>{module.value}</span>
          </NavLink>
        </li>
      )}
      {module.alias === "maps" && isMenuItemAvailable("maps") && (
        <li>
          <NavLink to="/event/module/map">
            <span>{module.value}</span>
          </NavLink>
        </li>
      )}
      {module.alias === "ddirectory" && isMenuItemAvailable("directory") && (
        <React.Fragment>
          {event !== undefined && event.defaultDirectory && event.directory_sub_modules !== undefined && event.directory_sub_modules.length > 0 && (
            <li className={`${currentPath && currentPath.includes("event/module/documents") ? "bold activeList" : ""}`}>
              <span style={{ lineHeight: "inherit" }}>
                <NavLink to={`/event/module/documents/agendas/${event.defaultDirectory.id}`}>
                  {module.value}
                </NavLink>
              </span>
              <ul>
                {event.directory_sub_modules !== undefined && event.directory_sub_modules.length > 0 && event.directory_sub_modules.map((menu, i) => renderDirectorySubModule(menu, i))}
              </ul>
            </li>
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  );
}
